import React from 'react';
import {Button} from 'components/antd';
import {
  useUpdateMailCampaignMutation,
  useCancelBlastengineBatchMutation,
  MailCampaign,
} from 'api';

interface Props {
  mailCampaign: MailCampaign;
}

export default ({mailCampaign}: Props) => {
  const [updateMailCampaign] = useUpdateMailCampaignMutation();
  const [cancelBlastengineBatch] = useCancelBlastengineBatchMutation();

  const canUseBlastengine =
    mailCampaign?.canDeliverBlastengine ||
    mailCampaign?.canDeliverBlastengineProspect;
  const cancellableStatuses = ['ready', 'blastengine_ready'];

  const cancel = () => {
    const userConfirmed = confirm(
      '送信予約がキャンセルされ、内容の編集が可能となります。よろしいですか？',
    );
    if (!userConfirmed) return;

    if (canUseBlastengine) {
      cancelBlastengineBatch({
        variables: {
          uuid: mailCampaign.uuid,
        },
      }).catch((e) => {
        alert(e.message);
      });
    } else {
      updateMailCampaign({
        variables: {
          uuid: mailCampaign.uuid,
          attributes: {
            status: 'draft',
          },
        },
      });
    }
  };

  // キャンセルの実処理（送信先の削除）はジョブで行うため、完了までボタンを押せなくする
  if (mailCampaign?.status === 'cancelling') {
    return (
      <Button type="primary" danger disabled loading>
        キャンセル処理中...
      </Button>
    );
  }

  return (
    cancellableStatuses.includes(mailCampaign?.status) && (
      <Button type="primary" danger onClick={cancel}>
        送信予約をキャンセルする
      </Button>
    )
  );
};
